import { render, staticRenderFns } from "./ModalChatPreview.vue?vue&type=template&id=4d2a815e&scoped=true&"
import script from "./ModalChatPreview.vue?vue&type=script&lang=js&"
export * from "./ModalChatPreview.vue?vue&type=script&lang=js&"
import style0 from "./ModalChatPreview.vue?vue&type=style&index=0&id=4d2a815e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2a815e",
  null
  
)

export default component.exports